
const rubricsType = {
    id: 1,
    category: "Introduction, Communication & Project Discussion",
    displayName: "Communication",
    description: "Assess clarity, confidence, and articulation through project discussion.",
    question_guidelines: [
        "Ask the candidate to introduce themselves and discuss a recent project they worked on.",
        "Encourage the candidate to explain their thought process and problem-solving approach.",
        "Focus on their role in the project and the challenges they faced.",
        "Ask a maximum of 2 questions in this category."
    ],
    evaluation_guidelines: [
        "Score based on clarity, articulation, and confidence in explaining technical and project details.",
        "Evaluate how well the candidate communicates their role and contributions."
    ]
};
const rubrics = [
    {
      id: 1,
      category: "Introduction,Communication & Project Discussion",
      displayName: "Communication",
      description: "Assess clarity, confidence, and articulation through project discussion.",
      question_guidelines: [
          "Ask the candidate to introduce themselves and discuss a recent project they worked on.",
          "Encourage the candidate to explain their thought process and problem-solving approach.",
          "Focus on their role in the project and the challenges they faced.",
          "Ask a maximum of 2 questions in this category."
      ],
      "specific_questions": [
          
      ],
      "evaluation_guidelines": [
          "Score based on clarity, articulation, and confidence in explaining technical and project details.",
          "Evaluate how well the candidate communicates their role and contributions."
      ]
 

    
    },
    {
      id: 2,
    
 
      "category": "Problem-Solving & Data Structures",
      "displayName": "Problem Solving",
      "description": "Evaluate problem-solving ability, algorithmic thinking, and knowledge of data structures.",
      "question_guidelines": [
          "Ask a minimum of 2 questions and a maximum of 2 questions related to data structures and algorithms.",
          "Vary the complexity based on the candidate's responses.",
          "Focus on problem-solving approach rather than just correctness."
      ],
      "specific_questions": [
          
      ],
      "evaluation_guidelines": [
          "Score based on clarity of explanation and problem-solving approach.",
          "Consider efficiency and correctness of the proposed solution."
      ]
    
    },
    {
      id: 3,
      "category": "Generative AI & LLMs",
      "displayName": "AI/ML Expertise",
      "description": "Evaluate knowledge of Generative AI, Large Language Models, and related architectures.",
      "question_guidelines": [
          "Ask a minimum of 2 questions and a maximum of 3 questions on Generative AI and LLMs.",
          "Cover model architectures like GPT, BERT, T5, LLaMA, and fine-tuning techniques.",
          "Discuss real-world applications and limitations."
      ],
      "specific_questions": [],
      "evaluation_guidelines": [
          "Score based on understanding of model architectures, training techniques, and practical applications.",
          "Evaluate ability to apply AI/ML concepts to real-world problems."
      ]
  },
  {
    id:4,
    "category": "Technical Programming Fundamentals",
    "displayName": "Tech Skills",
    "description": "Assess advanced programming concepts, code quality, and maintainability with Python as the primary language.",
    "question_guidelines": [
        "Ask a minimum of 2 questions and a maximum of 5 questions to understand their tech fundamentals.",
        "Increase the difficulty level based on the candidate's answers.",
        "Include topics such as object-oriented programming, error handling, and best coding practices."
    ],
    "specific_questions": [
    ],
    "evaluation_guidelines": [
        "Score based on coding efficiency, readability, and maintainability.",
        "Assess the candidate's ability to write clean, modular, and efficient code."
    ]
},
 
  ];

    const predefinedCategories = [
      {
        category: "Introduction, Communication & Project Discussion",
        displayName: "Communication",
      },
      {
        category: "Problem-Solving & Data Structures",
        displayName: "Problem Solving",
      },
      {
        category: "Technical Programming Fundamentals",
        displayName: "Tech Skills",
      },
      {
        category: "Generative AI & LLMs",
        displayName: "AI/ML Expertise",
      },
      {
        category: "NLP & Deep Learning",
        displayName: "NLP & Deep Learning",
      },
      {
        category: "API Development & Deployment",
        displayName: "Software Engineering",
      },
      {
        category: "Static Mandatory Questions",
        displayName: "Mandatory Questions",
      },
    ];
    const  phonepredefinedCategories = [
      {
        category: "Initial Greeting",
        displayName: "Introduction",
      },
      {
        category: "Introduction, Communication & Project Discussion",
        displayName: "Communication",
      },
      {
        category: "Problem-Solving & Data Structures",
        displayName: "Problem Solving",
      },
      {
        category: "Technical Programming Fundamentals",
        displayName: "Tech Skills",
      },
      {
        category: "Generative AI & LLMs",
        displayName: "AI/ML Expertise",
      },
      {
        category: "NLP & Deep Learning",
        displayName: "NLP & Deep Learning",
      },
      {
        category: "API Development & Deployment",
        displayName: "Software Engineering",
      },
      {
        category: "Static Mandatory Questions",
        displayName: "Mandatory Questions",
      },
    ];
  const defaultForm=
    {
      category: "Technical Programming Fundamentals",
      displayName: "Tech Skills",
      description:
        "Assess advanced programming concepts, code quality, and maintainability.",
      question_guidelines: [
        "Ask a minimum of 2 questions and a maximum of 5 questions to understand their tech fundamentals.",
        "Increase the difficulty level based on the candidate's answers.",
      ],
      specific_questions: [],
      evaluation_guidelines: [
        "Score based on coding efficiency, readability, and maintainability.",
        "Assess the candidate's ability to write clean, modular, and efficient code.",
      ],
      static_questions: [],
    };
    const phoneInitialValue=[
      {
        "category": "Initial Greeting",
        "displayName": "Introduction",
        "description": "Initial call introduction, availability check, and job interest screening.",
        "question_guidelines": [
          "Start with a polite greeting and check if it's a good time to talk.",
          "Introduce yourself as an AI recruiter from Kodiva.ai.",
          "Ask if the candidate is currently looking for job opportunities.",
          "If the timing isn't right, offer to reschedule.",
          "If the candidate is not looking, thank them and end the call."
        ],
        "specific_questions": [
          {
            "question": "Hello, this is Alex from Kodiva.ai. Is this a good time to chat?",
            "follow_up": [
              {
                "condition": "yes",
                "question": "Great! I'm calling regarding a job opportunity. Are you currently looking for job opportunities?"
              },
              {
                "condition": "no",
                "question": "No problem. When would be a better time to call you back?"
              }
            ]
          },
          {
            "question": "Are you currently looking for job opportunities?",
            "follow_up": [
              {
                "condition": "yes",
                "question": "Excellent! Could you please confirm your name?"
              },
              {
                "condition": "no",
                "question": "Thank you for your time. Have a great day!"
              }
            ]
          }
        ],
        "evaluation_guidelines": [
          "Evaluate based on professionalism, clarity, and the candidate's tone during the greeting.",
          "Assess willingness to proceed with the interview based on responses and engagement."
        ]
      },
      {
        "category": "Introduction, Communication & Project Discussion",
        "displayName": "Communication",
        "description": "Assess clarity, confidence, and articulation through project discussion.",
        "question_guidelines": [
          "Ask the candidate to introduce themselves and discuss a recent project they worked on.",
          "Encourage the candidate to explain their thought process and problem-solving approach.",
          "Focus on their role in the project and the challenges they faced.",
          "Ask a maximum of 2 questions in this category."
        ],
        "specific_questions": [],
        "evaluation_guidelines": [
          "Score based on clarity, articulation, and confidence in explaining technical and project details.",
          "Evaluate how well the candidate communicates their role and contributions."
        ]
      },
      {
        "category": "Technical Skills & Experience Validation",
        "displayName": "Technical Fit",
        "description": "Evaluate core technical knowledge and validate past experience with relevant technologies.",
        "question_guidelines": [
          "Pick a core skill or technology from the resume or job description.",
          "Ask the candidate how they have used it in their work.",
          "Optionally follow up with a high-level implementation or design question.",
          "Limit to 2-3 key questions in this section."
        ],
        "specific_questions": [],
        "evaluation_guidelines": [
          "Score based on depth and relevance of technical knowledge.",
          "Verify that their answers align with resume claims and role expectations."
        ]
      },
      {
        "category": "Static Mandatory Questions",
        "displayName":"Mandatory Questions",
        "description": "These questions must always be asked after all other questions are asked for the evaluation.",
        "question_guidelines": [
          "Ensure that all mandatory questions are asked before ending the interview.",
          "Ensure that mandatory questions are asked at the end of the interview."
        ],
        "specific_questions": [
          {
            "question": "Are you looking for job change?",
            "follow_up": [
              {
                "condition": "yes",
                "question": "What location are you open for?"
              },
              {
                "condition": "yes",
                "question": "What is your current CTC?"
              },
              {
                "condition": "yes",
                "question": "What is your expected CTC?"
              },
              {
                "condition": "yes",
                "question": "What is your notice period?"
              }
            ]
          }
        ],
        "evaluation_guidelines": []
      }
    ];
    const initialRubricsValue=[
      {
       "category": "Introduction, Communication & Project Discussion",
       "displayName": "Communication",
       "description": "Assess clarity, confidence, and articulation through project discussion.",
       "question_guidelines": [
        "Ask the candidate to introduce themselves and discuss a recent project they worked on.",
        "Encourage the candidate to explain their thought process and problem-solving approach.",
        "Focus on their role in the project and the challenges they faced.",
        "Ask a maximum of 2 questions in this category."
       ],
       "specific_questions": [],
       "evaluation_guidelines": [
        "Score based on clarity, articulation, and confidence in explaining technical and project details.",
        "Evaluate how well the candidate communicates their role and contributions."
       ]
      },
      {
       "category": "Technical Skills & Experience Validation",
       "displayName": "Technical Fit",
       "description": "Evaluate core technical knowledge and validate past experience with relevant technologies.",
       "question_guidelines": [
        "Pick a core skill or technology from the resume or job description.",
        "Ask the candidate how they have used it in their work.",
        "Optionally follow up with a high-level implementation or design question.",
        "Limit to 2-3 key questions in this section."
       ],
       "specific_questions": [],
       "evaluation_guidelines": [
        "Score based on depth and relevance of technical knowledge.",
        "Verify that their answers align with resume claims and role expectations."
       ]
      },
      {
       "category": "Problem Solving & Thinking",
       "displayName": "Problem Solving",
       "description": "Understand how the candidate approaches unfamiliar problems and decision-making.",
       "question_guidelines": [
        "Present a scenario or challenge and ask how the candidate would approach solving it.",
        "Look for structured thinking and logical flow.",
        "Do not focus on correctness, but on the process and reasoning."
       ],
       "specific_questions": [],
       "evaluation_guidelines": [
        "Score based on structured thinking, clarity in breaking down problems, and ability to explain trade-offs.",
        "Evaluate creativity and the ability to think on their feet."
       ]
      },
      {
       "category": "Static Mandatory Questions",
       "displayName":"Mandatory Questions",
       "description": "These questions must always be asked after all other questions are asked for the evaluation.",
       "question_guidelines": [
        "Ensure that all mandatory questions are asked before ending the interview.",
        "Ensure that mandatory questions are asked at the end of the interview."
       ],
       "specific_questions": [
        {
         "question": "Are you looking for job change?",
         "follow_up": [
          {
           "condition": "yes",
           "question": "What location are you open for?"
          },
          {
           "condition": "yes",
           "question": "What is your current CTC?"
          },
          {
           "condition": "yes",
           "question": "What is your expected CTC?"
          },
          {
           "condition": "yes",
           "question": "What is your notice period?"
          }
         ]
        }
       ],
       "evaluation_guidelines": []
      }
     ];
export { rubrics, rubricsType,defaultForm,predefinedCategories, initialRubricsValue ,phoneInitialValue,phonepredefinedCategories };